export default {
    setPlayerData(state) {
        state.selectedplayerData = state.allplayerData[state.selectedGamer];
      },
    setPlayer(state, payload){
      state.selectedGamer = payload.index;
    },
    setMySalary(state, payload){
      state.mySalary = payload.mySalary;
    }
}